import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class ShowList
  * A component which lists shows available to edit.
  */
export default class ShowList extends Component {
  /** @constructor
    * Constructs a new BoothList instance
    */
  constructor(props) {
    super(props);
    this.handleNewShow = this.handleNewShow.bind(this);
    this.handleDuplicate = this.handleDuplicate.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function handleNewShow
    * Creates a new show.
    */
  handleNewShow() {
    var newID = window.prompt("What id should be assigned to the new show (typically a year)", "");
    if(newID && newID !== "") {
      if(this.props.shows[newID]) {
        window.alert("That show id is already taken");
        return;
      }
      newID = newID.toLowerCase().replace(/[\s\\/]+/g, '-').replace();
      // Build the expo with default settings
      var show = {
        metadata: {
          name: `${newID} ${this.props.name}`,
          isSample: false,
          status: 'Under Construction',
          backgroundNoise: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fnoise.wav?alt=media&token=b21c5b22-9dea-41ae-b024-090ef15b6cb7",
          logo: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fvexpo-logo.png?alt=media&token=a1972550-76f7-461f-9b42-a8d3d951e78a",
          icon: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Ffavicon.ico?alt=media&token=f0b6d40a-f4bf-491f-aca6-de577143b637"
        },
        policies: {
          privacy: "<h1>Privacy Policy</h1>\n<p><strong>Updated 6/12/2018</strong></p>\n<p><br></p>\n<p>We understand your privacy is important to you, and we do our best to respect it as we hope others respect our own privacy. &nbsp;The following describes what information we collect, why, and how we use it.</p>\n<h3>Login Information</h3>\n<p>The show provides services like a personalized showbag where you can save the show giveaways, brochures, coupons, etc. &nbsp;To keep track of this information and allow you quick access across all your devices, we need to differentiate between people. &nbsp;For this reason, to attend the show please create an account using your email, Twitter, Facebook, or Instagram.</p>\n<p><br></p>\n<p>The Show does not share this login information with any business, show exhibitor, or third party. Your email will only be used to reset your password (should you forget it), and to send you notices of future shows. &nbsp;We dislike spam as much as you do, so we keep those notifications to a minimum.</p>\n<h3>Show Survey</h3>\n<p>We ask some attendees to fill out a show survey for the purpose of improving our show for future attendees. &nbsp;As a reward for participating, we offer a drawing for prizes among the participants. &nbsp;Clearly, we need to contact you if you win &nbsp;- so we ask in the survey for your email. If you choose not to include your contact info, your survey will be completely anonymous (but you will not be entered into the drawing).</p>\n<h3>Show Exhibitors</h3>\n<p>The Show provides links to exhibitor websites and resources outside of our show. &nbsp;These are not covered by our privacy policy, but by those of the individual exhibitor. &nbsp;Please consult their privacy policies for more information.</p>",
          tos: "<h1>Terms of Service</h1>\n<p><strong>Updated 6/12/2018</strong></p>\n<p><br></p>\n<p>The Show is a virtual outdoor sports exhibition you can attend on any computer or mobile device. This page describes the terms and conditions of utilizing this service. &nbsp;<strong>Any use of this service will constitute acceptance of these terms and conditions.</strong></p>\n<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>\n<p>Using the Show requires creating an account. &nbsp;What information is collected and how it is used is covered in our Privacy Policy.</p>\n<p><br></p>\n<p>The Show and its components are offered for informational purposes only; this Show shall not be responsible or liable for the accuracy, usefulness or availability of any information transmitted or made available via the Show, and shall not be responsible or liable for any error or omissions in that information.</p>\n<p><br></p>\n<p>The Show and its original content, features, and functionality are owned by Vexpo Shows and/or individual exhibitors in the show and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>\n<p><br></p>\n<p>The Show represents significant work and intellectual investment by a dedicated group. We ask that you respect that. &nbsp;By using the show, you agree not to reverse engineer, decompile, disassemble or otherwise attempt to derive the source code, techniques, processes, algorithms, know-how or other information from the HTML, JavaScript, and CSS source code, or permit or induce others to do so.</p>"
        },
        showbag: {
          background: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fcarryout-bag.png?alt=media&token=8c091923-7ade-425f-a568-3ed84f92689b",
          contents: {}
        },
        backgrounds: {
          exhibitorListing: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Fbooth-list.jpg?alt=media&token=23a31acf-cdb2-40af-9e42-4477c2f5b136",
          showLocations: "https://firebasestorage.googleapis.com/v0/b/vexpo-shows.appspot.com/o/default%2Flocation-kiosk.gif?alt=media&token=e3fdab2e-90df-4c9e-a163-9643dc756d58"
        },
        entry: {
          stage: {width: 1024, height: 768}
        },
        lobby: {
          stage: {width: 1024, height: 768}
        }
      }
      // Upload the new expo to the firebase database
      firebase.database().ref(`${this.props.dataURL}/${newID}`).set(show);
    }
  }
  /** @function handleDuplicate
    * Clones the specified show.
    * @param {string} id - the id of the show to clone
    */
  handleDuplicate(id) {
    var newID = window.prompt("What id should be assigned to the new show (typically a year)", "");
    if(newID && newID !== "") {
      if(this.props.shows[newID]) {
        window.alert("That show id is already taken");
        return;
      }
      newID = newID.toLowerCase().replace(/[\s\\/]+/g, '-').replace();
      // Clone the specified show
      var newShow = JSON.parse(JSON.stringify(this.props.shows[id]));
      newShow.metadata.name = `${newID} ${this.props.name}`;
      newShow.metadata.status = 'Under Construction';
      // Save new show to the database
      firebase.database().ref(`${this.props.dataURL}/${newID}`).set(newShow);
    }
  }
  /** @function handleRemove
    * Deletes the specified show and all its assets
    * @param {string} id - the id of the show to remove
    */
  handleRemove(id){
    if(window.confirm("Are you sure? This will permanently remove the show")) {
      // Remove the show
      firebase.database().ref(`${this.props.dataURL}/${id}`).set(null);
      // TODO: Need to remove assets
    }
  }
  /** @function render
    * Renders the component.
    */
  render() {
    var shows = [];
    for(var key in this.props.shows) {
      var show = this.props.shows[key];
      show.id = key;
      shows.push(show);
    }
    const columns = [
      {Header: 'Name', accessor: 'metadata.name'},
      {Header: 'Actions', accessor: 'id', Cell: (row) => (
        <div className="centered-text">
          <Link to={`${this.props.dataURL}/${row.value}/reports`}>
            <FontAwesome name="bar-chart"
              style={{color: "blue", cursor: "pointer"}}
              />
          </Link>
          <Link to={`${this.props.dataURL}/${row.value}`}>
            <FontAwesome name="edit"
              style={{color: "orange", cursor: "pointer"}}
              />
          </Link>
          <FontAwesome name="copy"
            style={{color: "green", cursor: "pointer"}}
            onClick={() => this.handleDuplicate(row.value)}
            />
          <FontAwesome name="times"
            style={{color: "red", cursor: "pointer"}}
            onClick={() => this.handleRemove(row.value)}
            />
        </div>
      )},
    ]
    return (
      <div>
        <button className="btn btn-success" onClick={this.handleNewShow}>
          <FontAwesome name="plus" />
          Add New Show
        </button>
        <ReactTable
          data={shows}
          columns={columns}
          defaultPageSize={10}
          />
      </div>
    )
    /*
    var shows = []
    for(var key in this.state.shows) {
      var show = this.state.shows[key];
      show.id = key;
      shows.push(show);
    }
    shows = shows.sort((a,b) => {
      return b.id.localeCompare(a.id)
    })
    const columns = [
      {Header: "Name", accessor: "metadata.name"},
      {Header: "Actions", accessor: "id", Cell: (row) => (
        <div className="centered-text">
          <FontAwesome name="edit" style={{color: 'orange', cursor: 'pointer'}}/>
        </div>
      )}
    ]

    return (
      <Editor>
        <ReactTable data={shows}
          columns={columns}
          />
      </Editor>
    )


    var shows = []
    for(var key in this.state.shows) {
      var show = this.state.shows[key];
      show.id = key;
      shows.push(show);
    }
    const items = shows.sort((a,b) => {
      return b.id.localeCompare(a.id)
    }).map(show => (
      <ShowListItem key={show.id}
        expoID={this.expoID}
        showID={show.id}
        editURL={`${this.dataURL}/${show.id}/settings`}
        {...show}/>
    ));

    return (
      <Editor>
        <table className="display-table">
          <thead>
            <tr>
              <th></th>
              <th>Show</th>
              <th>Last Release</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items}
          </tbody>
        </table>
      </Editor>
    )
    return (
      <Editor>
        <h2>Shows</h2>
        <div className="display-list">
          {items}
        </div>
        <button onClick={this.handleNewShow}>
          <FontAwesome name="plus"/>
          Add New Show
        </button>
      </Editor>
    );*/
  }
}



// WEBPACK FOOTER //
// ./src/expo-editor/show-list.js